import { Dispatch } from 'redux';
import SuggestionController from '../controllers/SuggestionController';
import commonHandler from '../errorHandlers/common-handler';
import { StoreState } from '../store-interfaces';
import CrudActionContainer from './CrudActionContainer';

class SuggestionsCRUDActions extends CrudActionContainer {
  constructor() {
    super('SUGGESTION');
  }

  retrieveAll(id: number) {
    return async (dispatch: Dispatch<StoreState>) => {
      dispatch(this.busy(this.retrieveAllAction));

      try {
        const response = await SuggestionController.getAll(id);
        dispatch(this.retrievedAll(response));
        return response;
      } catch (e) {
        return commonHandler(dispatch)(e);
      } finally {
        dispatch(this.unbusy());
      }
    };
  }

  discountSuggestion(id: number, suggestionId: number) {
    return async (dispatch: Dispatch<StoreState>) => {
      try {
        dispatch(this.busy(this.retrieveAllAction));

        const response = await SuggestionController.ignoreSuggestion(
          id,
          suggestionId,
        );
        dispatch(this.retrievedAll(response));
        return response;
      } catch (e) {
        return commonHandler(dispatch)(e);
      }
    };
  }
}

const suggestionsCRUDActions = new SuggestionsCRUDActions();

export default suggestionsCRUDActions;
